import { useAuth } from "@/context/AuthContext";
import { ShieldAlert } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Wraps a page and only renders it if the current user has the required capability.
 * Shows a friendly access-denied panel otherwise. Admin always passes.
 */
export default function CapabilityRoute({ capability, children }) {
  const { user } = useAuth();
  if (!user) return null;
  const caps = new Set(user.capabilities || []);
  if (user.role === "admin" || user.role === "admin_addl" || caps.has(capability)) return children;
  return (
    <div className="max-w-xl mx-auto mt-16 rounded-md border border-amber-200 bg-amber-50 p-6" data-testid="capability-denied">
      <div className="flex items-start gap-3">
        <ShieldAlert className="h-6 w-6 text-amber-700 shrink-0 mt-0.5" />
        <div>
          <div className="font-heading font-bold text-lg text-amber-900">Access restricted</div>
          <div className="text-[13px] text-amber-900/80 mt-1">
            Your role (<span className="font-mono">{user.role}</span>) doesn't have the <span className="font-mono">{capability}</span> capability enabled. Ask an administrator to grant this from <b>Roles &amp; Permissions</b>.
          </div>
          <Link to="/" className="mt-3 inline-block text-[12px] font-semibold text-amber-900 hover:underline">← Back to Dashboard</Link>
        </div>
      </div>
    </div>
  );
}
